import Vue from 'vue';
import Router from 'vue-router';
/**
 * 重写路由的push方法
 */
const routerPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return routerPush.call(this, location).catch((error) => error);
};

Vue.use(Router);

/* 路由模块集合 */
// 系统管理
import systemRouter from './modules/systemManage';
// 主数据中心
import masterDataRouter from './modules/masterData';
// 信用额度申请单
import creditRouter from './modules/purchaseSalesCenter/credit';
// 交易量额度
import tradingQuotaRouter from './modules/purchaseSalesCenter/tradingQuota';
// 结算管理
import settleRouter from './modules/capitalCenter/settle';
//仓储库存中心
import wareHouseRouter from './modules/wareHouse';
//物流中心
import logisticsRouter from './modules/logistics';
// 部门间交易
import departmentBusinessRouter from './modules/departmentBusiness';
//采购退换货
import purchaseReturnRouter from './modules/purchaseSalesCenter/purchaseReturn';
//销售退换货
import salesReturnRouter from './modules/purchaseSalesCenter/salesReturnsAndExchanges';
// 资金中心
import capitalRouter from './modules/capitalCenter';
// 财务中心
import financeRouter from './modules/financeCenter';

//资金计划
import capitalPlanRouter from './modules/capitalPlan';

// 合同相关：代理合同
import agencyContract from './modules/agencyContract';
// 销售采购中心
import salePurchaseCenter from './modules/salePurchaseCenter';
//消息中心
import messageCenter from './modules/messageCenter';

// 业务订单
import businessOrder from './modules/purchaseSalesCenter/businessOrder';
// 生产中心
import productionRouter from './modules/productionCenter';

// 期货策略
import futuresStrategyRouter from './modules/futuresStrategy';

//海宁客户余额
import customerBalanceRouter from './modules/purchaseSalesCenter/customerBalance';
//报表中心
import reportCenter from './modules/reportCenter';

// 流程管理
import flowableManage from './modules/flowableManage';

// // 信用-指标管理
import indicators from './modules/purchaseSalesCenter/indicators';

//项目额度
import projectQuotaRouter from './modules/purchaseSalesCenter/project';

import todoCenter from './modules/todoCenter';
// 仓库主数据
import storeMasterDataRouter from './modules/storeMasterData';
// 银行主数据
import bankMasterDataRouter from './modules/bankMasterData';
//应收应付
import receivablesAndPayablesRouter from './modules/receivablesAndPayables';

//经营统计
import managementStatisticsRouter from './modules/managementStatistics';

import projedctInitiation from './modules/projectInitiation';

//多式联运项目管理
import projectMgtRouter from './modules/intermodality/projectMgt';

import contractMgtRouter from './modules/intermodality/contractMgt';

//园区：仓储、监管
import parkWarehouseRouter from './modules/park/warehouse';
import superviseContractRouter from './modules/park/superviseContract';
import supervisionBillManagementRouter from './modules/park/supervisionBillManagement';
import SuperviseContractOverdueRouter from './modules/park/SuperviseContractOverdue';
import LeaseContractRouter from './modules/park/leaseContract';
import standingBook from './modules/standingBook';

// 多式联运订单管理
import orderRouter from './modules/order.js';

// 多式联运报表管理
import multimodalReport from './modules/multimodalReport.js';

// 物业模块
import propertymRouter from './modules/property';
// 电表
import meterManagementmRouter from './modules/energyConsumption/meterManagement';
// 水表
import waterMeterManagementmRouter from './modules/energyConsumption/waterMeterManagement';
import merchantCenterRouter from './modules/property/merchant';
import depositRouter from './modules/property/deposit';
//new报表中心
import reportManagement from './modules/reportManagement';
import tms from './modules/tms';
// 首页
import homePageRouter from './modules/homePage';
import homeRouter from './modules/home';

// 登录页
const login = () => import(/* webpackChunkName:'grounp' */ '@/pages/login.vue');
// oa登录
const sso = () => import(/* webpackChunkName:'grounp' */ '@/pages/sso.vue');
// redirect
const redirect = () => import(/* webpackChunkName:'grounp' */ '@/pages/redirect/index.vue');
// 主页面
const index = () => import(/* webpackChunkName:'grounp' */ '@/components/home.vue');
// 系统首页
const dashboard = () => import(/* webpackChunkName:'grounp' */ '@/pages/dashboard.vue');
// 403
const forbid = () => import(/* webpackChunkName:'grounp' */ '@/pages/403.vue');
// 404
const error = () => import(/* webpackChunkName:'grounp' */ '@/pages/404.vue');

const undevelopedPage = () =>
  import(/* webpackChunkName:'grounp' */ '../pages/undevelopedPage.vue');

//报表测试
const htmlViewSample = () => import(/* webpackChunkName:'grounp' */ '@/pages/htmlViewSample.vue');

let htmlViewSampleRouter = [];

for (let i = 0; i < 30; i++) {
  let route = {
    path: '/htmlViewSample' + (i ? i : ''),
    name: 'htmlViewSample' + (i ? i : ''),
    component: htmlViewSample,
    meta: {
      keepAlive: true,
      title: '报表' + (i ? i : ''),
    },
  };
  htmlViewSampleRouter.push(route);
}

export default new Router({
  routes: [
    {
      path: '/redirect',
      hidden: true,
      component: index,
      children: [
        {
          path: '/redirect/:path*',
          component: redirect,
        },
      ],
    },
    {
      path: '/',
      redirect: '/login',
    },
    {
      path: '/',
      component: index,
      children: [
        {
          path: '/dashboard',
          name: 'dashboard',
          component: dashboard,
          meta: {
            keepAlive: true,
            title: '首页',
            affix: true,
          },
        },
        {
          path: '/undevelopedPage',
          component: undevelopedPage,
          meta: { title: '敬请期待' },
        },
        {
          path: '/404',
          component: error,
          meta: { title: '404' },
        },
        {
          path: '/403',
          component: forbid,
          meta: { title: '403' },
        },
        ...htmlViewSampleRouter,
      ],
    },
    systemRouter,
    masterDataRouter,
    creditRouter,
    settleRouter,
    wareHouseRouter,
    tradingQuotaRouter,
    logisticsRouter,
    departmentBusinessRouter,
    projedctInitiation,
    projectMgtRouter,
    contractMgtRouter,
    parkWarehouseRouter,
    superviseContractRouter,
    supervisionBillManagementRouter,
    SuperviseContractOverdueRouter,
    LeaseContractRouter,
    standingBook,
    purchaseReturnRouter,
    salesReturnRouter,
    homeRouter,
    ...Object.values(capitalRouter),
    ...Object.values(financeRouter),
    ...Object.values(productionRouter),
    ...Object.values(futuresStrategyRouter),
    messageCenter,
    agencyContract,
    salePurchaseCenter,
    capitalPlanRouter,
    businessOrder,
    customerBalanceRouter,
    reportCenter,
    flowableManage,
    indicators,
    projectQuotaRouter,
    orderRouter,
    multimodalReport,
    todoCenter,
    receivablesAndPayablesRouter,
    managementStatisticsRouter,
    storeMasterDataRouter,
    bankMasterDataRouter,
    propertymRouter,
    meterManagementmRouter,
    waterMeterManagementmRouter,
    merchantCenterRouter,
    depositRouter,
    reportManagement,
    tms,
    homePageRouter,
    {
      name: 'sso',
      path: '/sso',
      component: sso,
    },
    {
      name: 'login',
      path: '/login',
      component: login,
    },
    {
      name: 'print',
      path: '/print',
      component: () => import('@/pages/reportManagement/printFile.vue'),
    },
    {
      path: '/storagePrint',
      name: 'storagePrint',
      component: () => import('@/pages/park/warehouse/reportManagement/print.vue'),
      meta: {
        keepAlive: true,
        title: '仓储打印',
      },
    },
    {
      path: '/workOrderPrint',
      name: 'workOrderPrint',
      component: () => import('@/pages/property/workorderManagement/print.vue'),
      meta: {
        keepAlive: true,
        title: '工单打印',
      },
    },
    {
      path: '*',
      redirect: '/404',
    },
  ],
});
